export enum FormSubmitStatus {
  /** Form has not been submitted yet. */
  NotSubmitted,

  /** Client-side validations are in progress. */
  DataValidationInProgress,

  /** No errors were found during client-side validations. */
  DataValidationSuccess,

  /** One or more of the client-side validations failed. */
  DataValidationError,

  /** Form has been submitted and awaiting for API response. */
  SubmitInProgress,

  /** Form has been submitted successfully. */
  SubmitSuccess,

  /** Form submission failed with a server-side or an unexpected error. */
  SubmitError
}
